import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { MprcContainer, MprcFormSubHeader, MprcRequestErrorReport, MprcRequestIndicator, MprcTypography } from "components";
import { MprcBoxDrawer } from "components/MprcBoxDrawer";
import { EnrollmentWorkflowStatus, EnrollmentWorkflowStatusResponse } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    enrollmentId: string;
    trainingName: string;
    onClose: () => void;
}

////////////////////////////////////////////////////////////////////////////////

export const WaitingApprovalDrawer: React.FC<IProps> = (props) => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { enrollmentId, trainingName, onClose } = props;
    const [loading, setLoading] = useState<boolean>(true);
    const viewData = useRef<EnrollmentWorkflowStatusResponse[]>([]);
    const [viewError, setViewError] = useState<any>(null);

    ///
    async function loadData() {
        try {
            const response = await api.v1.enrollment.getEnrollmentWorkflowStatusQuery({ enrollmentId });
            viewData.current = response.data;
        }
        catch (e) {
            setViewError(e);
        }
        finally {
            setLoading(false);
        }
    }

    ////////////////////////////////////////////////////////////////////////////////
    /// EFFECT's
    ////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        loadData();
    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////
    return (
        <>
            <MprcBoxDrawer
                onClose={() => onClose()}
                title={t("Student.EnrollmentView.Drawers.WaitingApproval.Title")}
                subtitle={trainingName}
                content={
                    <>
                        <MprcRequestIndicator visible={loading} />

                        {
                            viewError
                                ? <MprcRequestErrorReport error={viewError} />
                                : !loading &&
                                <MprcContainer>
                                    <MprcFormSubHeader title={t("Student.EnrollmentView.Drawers.WaitingApproval.SubHeaderTitle")} titleVariant="overline" />
                                    <List>
                                        {
                                            viewData.current.map(
                                                (item, index) =>
                                                (
                                                    <ListItem key={index} disableGutters>
                                                        <ListItemAvatar>
                                                            <Avatar
                                                                variant="circular"
                                                                src={item.approver.thumbnailUrl!}
                                                                sx={(theme) => ({ width: 40, height: 40 })}
                                                            />
                                                        </ListItemAvatar >
                                                        <ListItemText
                                                            disableTypography
                                                            primary={<MprcTypography noWrapRows={2} variant="body1" fontWeight="bold" title={item.approver.name}>{item.approver.name}</MprcTypography>}
                                                            secondary={
                                                                item.status == EnrollmentWorkflowStatus.Approved
                                                                    ? <MprcTypography variant="body2" color="success.main">
                                                                        {Formaters.performaDate(item.actionCompletedOn, { preText: t("Student.EnrollmentView.Drawers.WaitingApproval.ApprovedText") })}
                                                                    </MprcTypography>
                                                                    : <MprcTypography variant="body2">
                                                                        {item.status == EnrollmentWorkflowStatus.Pending && (index == 0 || (index == 1 && viewData.current[0].actionCompletedOn != null))
                                                                            ? t("Student.EnrollmentView.Drawers.WaitingApproval.WaitingAnalysisText")
                                                                            : t("Student.EnrollmentView.Drawers.WaitingApproval.WaitingPreviousText")
                                                                        }
                                                                    </MprcTypography>
                                                            }
                                                        >

                                                        </ListItemText>
                                                    </ListItem>
                                                )
                                            )
                                        }
                                    </List>
                                </MprcContainer>
                        }
                    </>
                }
            />
        </>
    );
};
